module.exports = __webpack_public_path__ + "media/images/allcare-app@2x-54601d36682c8fe6f7ec44f0d4a320d7.webp";